// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__5__3z","modal__wrap":"Modal_modal__wrap__WcYwa","opened":"Modal_opened__FnB6X"};